<div class="actions-container">

	<div *ngIf="!!webShop" class="weblinks">
		<div class="weblinks-container" *ngIf="webLinks.length">

			<a class="webshop-container"
			   [href]="webLink.url"
			   target="_blank"
			   *ngFor="let webLink of webLinks" [class]="webLink.css_class">
				<span class="short" tt>{{ webLink.name }}</span>
			</a>

		</div>

		<a [href]="webShop.url" class="webshop-container">
			<span class="short" tt>{{ webShop.item_name }}</span>
		</a>

		<menu-header-submenu *ngIf="!!language"
		                     [heading]="language.label"
		                     [items]="language.submenu">
		</menu-header-submenu>
	</div>

	<div *ngIf="!!language"
	     class="language-container"
	     (mouseenter)="language.hover = true"
	     (mouseleave)="language.hover = false"
	     [attr.data-hover-active]="language.hover">
		<span class="short">{{ current_language_shortname }}</span>
		<div class="icon-public"></div>

		<menu-header-submenu [heading]="language.label"
		                     [items]="language.submenu">
		</menu-header-submenu>
	</div>

	<div *ngIf="!!help"
	     class="help-container"
	     (mouseenter)="help.hover = true"
	     (mouseleave)="help.hover = false"
	     [attr.data-hover-active]="help.hover">
		<div class="icon-help"></div>
		<menu-header-submenu [heading]="help.label"
		                     [items]="help.submenu">
		</menu-header-submenu>
	</div>

	<div *ngIf="!!notifications"
	     class="notifications-container">
		<div class="icon-bullhorn"
		     [class.has-unread]="notificationsComponent?.hasUnreadNotifications"
		     (click)="toggleNotifications()">
			<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 640'>
				<path fill='#eca823'
				      d='M320 64C302.3 64 288 78.3 288 96L288 99.2C215 114 160 178.6 160 256L160 277.7C160 325.8 143.6 372.5 113.6 410.1L103.8 422.3C98.7 428.6 96 436.4 96 444.5C96 464.1 111.9 480 131.5 480L508.4 480C528 480 543.9 464.1 543.9 444.5C543.9 436.4 541.2 428.6 536.1 422.3L526.3 410.1C496.4 372.5 480 325.8 480 277.7L480 256C480 178.6 425 114 352 99.2L352 96C352 78.3 337.7 64 320 64zM258 528C265.1 555.6 290.2 576 320 576C349.8 576 374.9 555.6 382 528L258 528z'/>
			</svg>
			<span class="notifications-badge" *ngIf="notificationsComponent?.hasUnreadNotifications">
				{{ notificationsComponent.unreadCount }}
			</span>
		</div>
		<menu-header-notifications #notificationsComponent></menu-header-notifications>
	</div>

	<div *ngIf="!!account"
	     class="account-container"
	     (mouseenter)="account.hover = true"
	     (mouseleave)="account.hover = false"
	     [attr.data-hover-active]="account.hover">
		<div class="icon-account_circle"></div>
		<menu-header-submenu [heading]="userName"
		                     [items]="account.submenu">
			<menu-color-scheme-toggle></menu-color-scheme-toggle>
		</menu-header-submenu>
	</div>

	<div *ngIf="!!logoutLink"
	     class="logout-container"
	     [title]="logoutLink.label">
		<a [href]="logoutLink.url">
			<div class="icon-logout"></div>
		</a>
	</div>

</div>
